
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var RegularApplyPage = Vue.extend({})
Vue.component('regularApply-page', RegularApplyPage)

export default {
  name: 'RegularApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/hr/regularApply.vue